var $7115429b0f60511f$exports = {};
$7115429b0f60511f$exports = {
  "dragDescriptionKeyboard": "Naci\u015Bnij Enter, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragDescriptionKeyboardAlt": "Naci\u015Bnij Alt + Enter, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragDescriptionLongPress": "Naci\u015Bnij i przytrzymaj, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragDescriptionTouch": "Dotknij dwukrotnie, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragDescriptionVirtual": "Kliknij, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragItem": function dragItem(args) {
    return "Przeci\u0105gnij ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Przeci\u0105gnij ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " wybrany element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " wybranych element\xF3w");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Naci\u015Bnij Enter, aby przeci\u0105gn\u0105\u0107 ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " wybrany element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " wybrane(-ych) elementy(-\xF3w)");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Naci\u015Bnij Alt + Enter, aby przeci\u0105gn\u0105\u0107 ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " wybrany element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " wybrane(-ych) elementy(-\xF3w)");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Naci\u015Bnij i przytrzymaj, aby przeci\u0105gn\u0105\u0107 ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " wybrany element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " wybrane(-ych) elementy(-\xF3w)");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Rozpocz\u0119to przeci\u0105ganie. Naci\u015Bnij Tab, aby wybra\u0107 miejsce docelowe, a nast\u0119pnie naci\u015Bnij Enter, aby upu\u015Bci\u0107, lub Escape, aby anulowa\u0107.",
  "dragStartedTouch": "Rozpocz\u0119to przeci\u0105ganie. Wybierz miejsce, w kt\xF3rym chcesz upu\u015Bci\u0107 element, a nast\u0119pnie dotknij dwukrotnie, aby upu\u015Bci\u0107.F",
  "dragStartedVirtual": "Rozpocz\u0119to przeci\u0105ganie. Wybierz miejsce, w kt\xF3rym chcesz upu\u015Bci\u0107 element, a nast\u0119pnie kliknij lub naci\u015Bnij Enter, aby upu\u015Bci\u0107.",
  "dropCanceled": "Anulowano upuszczenie.",
  "dropComplete": "Zako\u0144czono upuszczanie.",
  "dropDescriptionKeyboard": "Naci\u015Bnij Enter, aby upu\u015Bci\u0107. Naci\u015Bnij Escape, aby anulowa\u0107 przeci\u0105gni\u0119cie.",
  "dropDescriptionTouch": "Dotknij dwukrotnie, aby upu\u015Bci\u0107.",
  "dropDescriptionVirtual": "Kliknij, aby upu\u015Bci\u0107.",
  "dropIndicator": "wska\u017Anik upuszczenia",
  "dropOnItem": function dropOnItem(args) {
    return "Upu\u015B\u0107 na ".concat(args.itemText);
  },
  "dropOnRoot": "Upu\u015B\u0107",
  "endDragKeyboard": "Przeci\u0105ganie. Naci\u015Bnij Enter, aby anulowa\u0107 przeci\u0105gni\u0119cie.",
  "endDragTouch": "Przeci\u0105ganie. Kliknij dwukrotnie, aby anulowa\u0107 przeci\u0105gni\u0119cie.",
  "endDragVirtual": "Przeci\u0105ganie. Kliknij, aby anulowa\u0107 przeci\u0105ganie.",
  "insertAfter": function insertAfter(args) {
    return "Umie\u015B\u0107 za ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Umie\u015B\u0107 przed ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Umie\u015B\u0107 mi\u0119dzy ".concat(args.beforeItemText, " i ").concat(args.afterItemText);
  }
};
export { $7115429b0f60511f$exports as default };